import axios from 'axios'

function extractMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const msg = error.response?.data?.error?.message
    if (typeof msg === 'string') return msg
    return error.message
  }
  if (error instanceof Error) return error.message
  return 'Произошла ошибка'
}

export function ErrorMessage({ error }: { error: unknown }) {
  const message = extractMessage(error)
  return (
    <div className="rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
      {message}
    </div>
  )
}
